import React from 'react';

import classNames from 'classnames';

import { GenericListRowProps } from '@app/common/components/ListRow/ListRow';

import styles from './ListRow.pcss';

export interface ListRowPropsLi extends GenericListRowProps<HTMLLIElement> {
}

export const ListRowLi: React.FC<ListRowPropsLi> = React.forwardRef((
  props: ListRowPropsLi,
  ref: React.Ref<HTMLLIElement>,
) => {
  const {
    // eslint-disable-next-line i18next/no-literal-string
    'data-stable-name': dataStableName,
    className,
    children,
    prefixIcon,
    suffixIcon,
    ...other
  } = props;
  return (
    <li
      className={classNames(styles.listRow, className)}
      data-stable-name={dataStableName}
      ref={ref}
      {...other}
    >
      {prefixIcon !== undefined ? prefixIcon : <span />}
      <div className={styles.rowContent}>{children}</div>
      {suffixIcon !== undefined ? suffixIcon : <span />}
    </li>
  );
});
